// Var-call helpers for `${...}` expression parsing and resolution.
// Example: `var(--sizes[ind])` and `var(--theme[key])` resolve at compile time.
import type { LuisArrayVariables, LuisObjectVariables } from '../../types'
import { parseExpressionVarCall, readVarCallToken } from './placeholder-expression-var-parse'
import { resolveParsedVarExpressionValue } from './placeholder-expression-var-resolve'
import type { LoopExpressionValue } from './placeholder-expression-types'

export { readVarCallToken } from './placeholder-expression-var-parse'

// Resolve one normalized `var(...)` expression token into a typed value.
export function resolveVarExpressionValue(
  token: string,
  scope: Record<string, string>,
  arrays: LuisArrayVariables,
  variables: Record<string, string>,
  objectVariables: LuisObjectVariables,
): LoopExpressionValue | null {
  const parsed = parseExpressionVarCall(token, 0)
  // Reject malformed normalized var-call tokens.
  if (!parsed || parsed.end !== token.length) {
    return null
  } else {
    // Return the resolved compile-time var-call value.
    return resolveParsedVarExpressionValue(parsed.value, scope, arrays, variables, objectVariables)
  }
}
